import { differenceInCalendarDays, format as formatDate } from 'date-fns';
import { fromZonedTime } from 'date-fns-tz';

function getLocalTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

function convertDateToUTC(date: string, timezone?: string) {
  if (!timezone) {
    timezone = getLocalTimeZone();
  }

  return fromZonedTime(new Date(date), timezone);
}

// Format 'Date' (or) date 'string' in policy for display.
function formatDateInPolicy(date: string | number | Date) {
  return formatDate(date, 'dd LLL yyyy');
}

// Format 'Date' (or) date 'string' to assign to a policy.
function formatDateForPolicy(date: string | number | Date) {
  return formatDate(date, 'yyyy-MM-dd');
}

// Format 'Date' (or) date 'string' in claim for display.
function formatDateInClaim(date: string | number | Date) {
  return formatDate(date, 'dd MMMM yyyy');
}

// Format 'Date' (or) date 'string' to assign to a claim.
function formatDateForClaim(date: string | number | Date) {
  return new Date(date).toISOString();
}

function getHasBeen20DaysSince(date: string | number | Date) {
  return differenceInCalendarDays(new Date(), date) > 20;
}

export { compareDesc as compareDatesDesc, differenceInDays } from 'date-fns';
export {
  convertDateToUTC,
  formatDateForClaim,
  formatDateForPolicy,
  formatDateInClaim,
  formatDateInPolicy,
  getHasBeen20DaysSince,
  getLocalTimeZone,
};
